/* Blindspot — premium autoplay guard.
   Every ambient video plays on its own, looped, muted, inline — no play buttons.
   Handles: iOS Low Power Mode (retry on first gesture), tab return / bfcache
   resume, and late-rendered videos (product galleries, section rerenders). */
(() => {
  const nearViewport = (v) => {
    const r = v.getBoundingClientRect();
    return r.top < innerHeight * 2 && r.bottom > -innerHeight;
  };

  const kick = () => {
    document.querySelectorAll('video').forEach((v) => {
      const lazy = v.hasAttribute('data-bs-lazy-video');
      const wantsAuto = v.autoplay || v.hasAttribute('autoplay') || lazy;
      if (!wantsAuto || !v.paused) return;
      if (lazy && !nearViewport(v)) return;
      v.muted = true;
      v.playsInline = true;
      v.loop = true;
      const p = v.play();
      if (p) p.catch(() => {});
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kick);
  } else {
    kick();
  }
  window.addEventListener('load', kick);

  // First user gesture unlocks playback when the browser blocked autoplay
  ['touchstart', 'click', 'scroll'].forEach((t) => {
    window.addEventListener(t, kick, { once: true, passive: true, capture: true });
  });

  // Resume when coming back to the tab or from the back/forward cache
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) kick();
  });
  window.addEventListener('pageshow', kick);

  // Late-rendered videos (variant/media swaps, section rehydration)
  new MutationObserver((muts) => {
    for (const m of muts) {
      for (const n of m.addedNodes) {
        if (n.nodeType === 1 && (n.tagName === 'VIDEO' || (n.querySelector && n.querySelector('video')))) {
          kick();
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
